function removeBundle(parentEle) {
  const listItems = parentEle.querySelectorAll('[data-line-item-key]');
  let bundle_items_array = [];
  listItems.forEach((item, index) => {
   const get_id = item.getAttribute("data-line-item-key").split(':')[0];
    bundle_items_array.push({ id: get_id, quantity: 0 });
  });
  console.log("bundle_items_array: ", bundle_items_array);
      const data = {
      updates: Object.fromEntries(bundle_items_array.map(item => [item.id, item.quantity]))
    };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
      .then(response => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then(cart => {
        const get_subtotal = (cart.items_subtotal_price / 100).toFixed(2);
        updateCartDrawer(cart.item_count, get_subtotal);
      })
      .catch(async error => {
        const errorMsg = (await error.json()).description || "An unknown error occurred.";
        alert(`!Error: ${errorMsg}. Try Again...`);
      });
}

// UPDATE THE CART DRAWER UI
function updateCartDrawer(cartQuantity, cartSubTotal) {
  fetch('/cart?id=right-drawer-slot')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');
      const updatedSection = newDocument.querySelector('[data-cart-items]');
      const subTotal = document.querySelector("[cart-subtotal]");
      const cartPage_subTotal =  document.querySelector("[data-cartPage-subtotal-price]");

      if (updatedSection) {
        document.querySelector('[data-cart-items]').innerHTML = updatedSection.innerHTML;
        document.querySelectorAll('[data-cart-mb] span, [data-cart-dekstop] span').forEach((item) => {
          item.textContent = `${cartQuantity}`;
        });
        document.querySelector('[data-cart-title] span').innerHTML = `${cartQuantity} ITEM`;
        if (subTotal) {
          subTotal.innerHTML = "$" + cartSubTotal + " " + "USD";
        }
        if (cartPage_subTotal) {
          cartPage_subTotal.innerHTML = "$" + cartSubTotal + " " + "USD";
        }
          
      }
    })
    .catch(error => {
      console.error('Error updating the section:', error);
    });
}
